import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <div className="privacy">
      <Header />
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Cookie Policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte prose max-w-none">
            <p><strong>Last updated: September 8, 2026</strong></p>
            <p>
              This Cookie Policy explains how Petoutlet uses cookies and similar
              technologies when you visit our website. It should be read with
              our Privacy Policy.
            </p>

            <h2>1. What cookies are</h2>
            <p>
              Cookies are small text files stored on your device. Similar
              technologies, such as local storage and pixels, may perform
              related functions. They can remember preferences, keep a cart
              working, help protect transactions, and show us how the website is
              used.
            </p>

            <h2>2. Cookies we may use</h2>
            <ul>
              <li><strong>Strictly necessary:</strong> support security, checkout, cart, and core site functions.</li>
              <li><strong>Preference:</strong> remember choices such as language, region, or display settings.</li>
              <li><strong>Analytics:</strong> help us understand page performance and improve the shopping experience.</li>
              <li><strong>Marketing:</strong> measure campaigns or personalize promotions only where enabled and permitted.</li>
            </ul>

            <h2>3. Third-party technologies</h2>
            <p>
              Service providers supporting hosting, payment, fraud prevention,
              analytics, or other site functions may set their own cookies when
              those services are active. Their use of information is governed
              by their own notices and our agreements with them.
            </p>

            <h2>4. Your choices</h2>
            <p>
              You can block or delete cookies through your browser settings.
              Blocking strictly necessary cookies may prevent the cart,
              checkout, or other parts of the website from working correctly.
              Where a consent control is displayed, you may also use it to
              update non-essential cookie choices.
            </p>

            <h2>5. Retention</h2>
            <p>
              Session cookies expire when you close your browser. Persistent
              cookies remain for the period shown in the relevant cookie or
              until you delete them. We ask service providers to retain related
              information only as long as needed for the stated purpose.
            </p>

            <h2>6. Changes and contact</h2>
            <p>
              We may update this policy as our technology or legal obligations
              change. Questions or requests can be sent to{" "}
              <a href="mailto:audit@petoutlet.work">audit@petoutlet.work</a>.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CookiePolicy;
